export function propertyIterator() {
	const properties = Object.keys(this);
	let count = 0;

	return {
		next: () => {
			return {
				done: count >= properties.length,
				value: this[properties[count++]],
			};
		},
	};
}

export function iterableObject(obj = {}) {
	obj[Symbol.iterator] = propertyIterator;
	return obj;
}
